import { render } from "./CertiAccManage.vue?vue&type=template&id=976eda80"
import script from "./CertiAccManage.vue?vue&type=script&lang=js"
export * from "./CertiAccManage.vue?vue&type=script&lang=js"

import "./CertiAccManage.vue?vue&type=style&index=0&id=976eda80&lang=css"
import "./CertiAccManage.vue?vue&type=style&index=1&id=976eda80&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__